import React from 'react';
import { func } from 'prop-types';
import { StringConstantsMixin } from '../../../application/javascripts/react_components/mixins/shared/string_constants_mixin';
import { wrapEventHandler } from '../../../utils/handlers';
import CircleButton from '../../shared/CircleButton';
import printIcon from '../../../../assets/images/icons/trail/icons-buttons-print.svg';
import { mapActionButton, container } from './styles.module.scss';

const CtaControls = ({ handlePrintClick }) => {
  return (
    <div className={container}>
      {handlePrintClick && (
        <CircleButton
          large
          print
          icon={printIcon}
          className={mapActionButton}
          onClick={wrapEventHandler(handlePrintClick)}
          title={StringConstantsMixin.strings.PRINT_MAP}
        />
      )}
    </div>
  );
};

CtaControls.propTypes = {
  handlePrintClick: func
};

CtaControls.defaultProps = {
  handlePrintClick: null
};

export default CtaControls;
